module.exports = __webpack_public_path__ + "static/media/usdc.2caecb02.svg";